import { createFileRoute } from "@tanstack/react-router";
import { SupplierCatalogPriceTab } from "../../../../pages/suppliers-page/supplier-catalog-price-tab";

export const Route = createFileRoute("/_auth/_frame/suppliers/$supplierId/catalog-prices")({
  component: SupplierCatalogPriceTab,
});
